import React from "react";

const Year = React.memo(() => {
  const currentYear = new Date().getFullYear();
  return [1, 2, 3, 4, 5, 6].map((rec) => (
    <option key={currentYear - 1 + rec} value={currentYear - 1 + rec}>
      {currentYear - 1 + rec}
    </option>
  ));
});

export default Year;
